module.exports = __webpack_public_path__ + "img/csr_swiper_04_08.d1eaafbd.jpg";